
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { feature } = api;

@Component({})
export default class ServiceUpdateList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private loading = false;

  private headers = [
    { text: '標題', value: 'title', width: '30%' },
    { text: '網址', value: 'link', width: '45%' },
    { text: '上架時間', value: 'startOn', width: '15%' },
    { text: '編輯', value: 'edit', width: '5%' },
    { text: '刪除', value: 'delete', width: '5%' },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async remove(id: any) {
    await Swal.fire(
      {
        title: '你確定要刪除嗎?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status } = await feature.delete(id);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '刪除成功' });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: '刪除失敗，請聯繫系統管理員。' });
        }
      }
    });
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async query() {
    const query = {
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    } else {
      await this.requestData();
    }
  }

  private async reset() {
    this.filter = {
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await feature.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: ServiceUpdateList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }

  private async beforeRouteUpdate(
    to: Route,
    from: Route,
    next: (to?: ((vm: ServiceUpdateList) => void) | boolean) => void,
  ) {
    if (to.name === 'serviceUpdateList') await this.requestData();
    await next(true);
  }
}
